module.exports = __webpack_public_path__ + "static/media/due-port12.2457a61b.jpg";